import * as types from '../mutation-types'
import axios from 'axios'


// state
export const state = {
  messages: [],
  message_stubs: [],
  message_notifications: [],
  recipient: null,
  loaded:{
    notifications:false,
    messages:false,
    message_stubs:false,
  }
}

// getters
export const getters = {
  message_stubs: state => state.message_stubs,
  messages: state => state.messages,
  message_notifications: state => state.message_notifications,
  recipient: state => state.recipient,
  loaded: state => state.loaded,
}

// mutations
export const mutations = {
  [types.GET_MESSAGE_NOTIFICATIONS](state, data) {
    state.message_notifications = data
    state.loaded.notifications = true;
  },
  [types.GET_CONVERSATION](state, resp) {
    console.log('GET_CONVERSATION') 
    state.messages = resp.data
    state.loaded.messages = true;
  },
  [types.GET_MESSAGE_STUBS](state, data) {
    state.message_stubs = data
    state.loaded.message_stubs = true;
  },
  [types.INSERT_NOTIFICATION](state, notification) {
    state.message_notifications.push(notification)
  },
  [types.INSERT_MESSAGE](state, message) {
    state.messages.push(message)
  },
  [types.GET_RECIPIENT](state, recipient) {
    state.recipient = recipient
  },
}

// actions
export const actions = {
  getMessageNotifications({ commit, state }, params) {
    state.loaded.notifications = false
    return axios.get('/api/message_notifications', params)
      .then((resp) => {
        commit(types.GET_MESSAGE_NOTIFICATIONS, resp.data)
      });
  },
  getMessageStubs({ commit, state }) {
    state.loaded.message_stubs = false
    return axios.get('/api/message_stubs')
      .then((response) => {
        commit(types.GET_MESSAGE_STUBS, response.data)
      })
      
  },
  getConversation({ commit, state }, params) {
    state.loaded.messages = false
    return axios.get('/api/conversation', { params })
      .then((response) => {
        commit(types.GET_CONVERSATION, response)
      })
      
  },
  setMessageAsRead({ commit, state }, params) {
    return axios.get('/api/message_read', { params })
      
  },
  setConversationResolved({ commit, state }, params) {
    return axios.get('/api/conversation_resolved',  { params })
      .then((response) => {
        commit(types.GET_CONVERSATION, response)
      })
      
  },
  getRecipient({ commit, state }, params) {
    return axios.get('/api/messages/recipient', { params })
      .then((response) => {
        commit(types.GET_RECIPIENT, response.data)
      })
      
  },
  setRecipient({ commit, state }, recipient) {
    commit(types.GET_RECIPIENT, recipient);
  },
  insertNotification({ commit, state }, notification) {
    console.log('insertNotification')
    commit(types.INSERT_NOTIFICATION, notification)
  },
  insertMessage({ commit, state }, message) {
    console.log('insertMessage')
    commit(types.INSERT_MESSAGE, message)
  },
  sendMessage({ commit, state }, request) {
    return axios.post('/api/message', request)
      .then((response) => {
        commit(types.GET_CONVERSATION, response)
      })
  },
}
